// services/dataProcessing.service.js
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL_API;

export const dataProcessingService = {
  async processAxisData(formData) {
    try {
      const response = await axios.post(`${baseUrl}api/process-axis-data/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Token ${this.getAuthToken()}`
        },
        timeout: 30000 // 30 segundos para upload
      });
      return response.data;
    } catch (error) {
      console.error('Erro no processamento:', error);
      throw new Error(error.response?.data?.error || error.response?.data?.message || 'Erro no processamento');
    }
  },

  async getProcessingStatus(taskId) {
    try {
      const response = await axios.get(`${baseUrl}api/processing-status/${taskId}/`, {
        headers: {
          'Authorization': `Token ${this.getAuthToken()}`
        },
        timeout: 10000
      });
      
      // Validar se o status é confiável
      const data = response.data;
      
      if (data.status === 'COMPLETED' && !data.has_results) {
        return {
          ...data,
          status: 'FAILED',
          error_message: 'Processamento concluído sem resultados válidos'
        };
      }
      
      return data;
    } catch (error) {
      console.error('Erro ao verificar status:', error);
      throw new Error(error.response?.data?.message || 'Erro ao verificar status do processamento');
    }
  },

  async downloadResult(fileType, taskId) {
    try {
      const response = await axios.get(`${baseUrl}api/download-result/${fileType}/${taskId}/`, {
        responseType: 'blob',
        headers: {
          'Authorization': `Token ${this.getAuthToken()}`
        },
        timeout: 30000
      });
      
      if (response.data.size < 100) {
        const errorText = await response.data.text();
        if (errorText.includes('error') || errorText.includes('Error')) {
          throw new Error('Arquivo de resultado inválido');
        }
      }
      
      return response;
    } catch (error) {
      console.error('Erro no download:', error);
      throw new Error(error.response?.data?.message || 'Erro ao baixar resultado');
    }
  },

  getAuthToken() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      return user.token;
    }
    return null;
  }
};